import { useCallback, useState } from 'react';
import { selectRoomSnapshot } from '../services/RoomSnapshot';
import { getRoomMembershipVersion } from '../services/RoomSession';

export const useRoomSnapshot = (roomId, playerId) => {
    const [roomData, storeRoomData] = useState(null);
    const setRoomData = useCallback(incoming => {
        storeRoomData(current => selectRoomSnapshot(current, incoming, roomId, playerId, getRoomMembershipVersion(roomId)));
    }, [roomId, playerId]);
    // Never keep a second, independently cleared copy of the table card. A late
    // HTTP response may be rejected while the newer hub snapshot stays unchanged.
    return { roomData, setRoomData, currentDiscardedCard: roomData?.currentDiscardedCard ?? null };
};
